var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSizingRulerLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 648 85"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip-path)",
  "data-name": "Mask Group 1226",
  transform: "translate(-315 -774)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9823"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9819"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "m894.713 845.015-.413-69.724 66.585-.181.115 69.607Z",
  "data-name": "Path 6045"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#b7b8b6",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.3,
  d: "M396.688 844.717h-71.6v-69.733h73.6",
  "data-name": "Path 6046"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fafafa",
  stroke: "#b7b8b6",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.3,
  d: "M814.354 774.983h275.287v69.733H810.253",
  "data-name": "Path 6047"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fafafa",
  d: "M961 775v70H315.917v-70Z",
  "data-name": "Path 6048"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9820"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M318.398 858.779a3.4 3.4 0 0 0 3.214-2.291c1.588-3.62 2.324-3.17 4.18-5.753.5-.693 3.1-4.406 4.9-6.984a3.047 3.047 0 0 0-.786-4.268s-5.884 8.383-6.611 9.349c-1.308 1.738-1.029 2.154-2.45 4.186a3.4 3.4 0 1 0-2.445 5.761m6.08-9.547a.673.673 0 1 1-.674.673.67.67 0 0 1 .674-.673m-7.06 5.582a1.186 1.186 0 1 1 .21 1.9 1.386 1.386 0 0 1-.21-1.9",
  "data-name": "Path 6049"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M328.113 853.018a13 13 0 0 1-1.093-1.837q-.13.185-.206.288a15 15 0 0 1-1.458 1.756 10.6 10.6 0 0 1 1.987 3.263 3.4 3.4 0 1 0 .77-3.47m3.424 1.8a1.186 1.186 0 1 1-1.75-.768 1.384 1.384 0 0 1 1.75.768",
  "data-name": "Path 6050"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M321.788 848.785c.142-.217.306-.45.5-.709s.725-1 1.419-1.981c-1.967-2.781-4.656-6.612-4.656-6.612a3.05 3.05 0 0 0-.786 4.269c1.1 1.569 2.49 3.559 3.523 5.033",
  "data-name": "Path 6051"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M1097.365 763a3.29 3.29 0 0 0-3.114 2.222c-1.54 3.507-2.252 3.07-4.051 5.574-.483.673-3 4.271-4.747 6.767a2.954 2.954 0 0 0 .762 4.137s5.7-8.124 6.407-9.059c1.267-1.685 1-2.089 2.375-4.059a3.293 3.293 0 1 0 2.368-5.582m-5.887 9.253a.653.653 0 1 1 .653-.652.653.653 0 0 1-.653.652m6.837-5.41a1.34 1.34 0 0 1-1.7.744 1.564 1.564 0 1 1 1.7-.744",
  "data-name": "Path 6052"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M1087.951 768.582a12.3 12.3 0 0 1 1.059 1.783q.127-.181.2-.28a15 15 0 0 1 1.414-1.7 10.3 10.3 0 0 1-1.926-3.161 3.3 3.3 0 1 0-.746 3.36m-3.319-1.741a1.15 1.15 0 1 1 1.7.744 1.34 1.34 0 0 1-1.7-.744",
  "data-name": "Path 6053"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1311",
  d: "M1094.078 772.686c-.137.209-.295.437-.484.687s-.7.97-1.375 1.919c1.906 2.7 4.511 6.408 4.511 6.408a2.955 2.955 0 0 0 .763-4.137z",
  "data-name": "Path 6054"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1092.104 773.624v7.042h-11.958v-7.042z",
  "data-name": "Rectangle 25237"
})), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 4.715 797.755)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 1.92 800.55)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -.88 803.35)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -9.4 783.64)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -12.195 786.434)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -14.995 789.235)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -23.515 769.525)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -26.31 772.32)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -29.11 775.12)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -37.69 755.35)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 3,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -40.484 758.144)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "3")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -43.285 760.945)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -51.865 741.175)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 4,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -54.66 743.97)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "4")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -57.46 746.77)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -66.064 726.975)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 5,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -68.859 729.77)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "5")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -71.659 732.57)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -80.209 712.83)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 6,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -83.004 715.625)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "6")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -85.804 718.425)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -94.354 698.685)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 7,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -97.149 701.48)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "7")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -99.949 704.28)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -108.499 684.54)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 8,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -111.294 687.335)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "8")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -114.094 690.135)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -122.729 670.31)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 9,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -125.524 673.105)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "9")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -128.324 675.905)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -136.959 656.08)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -139.754 658.875)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -142.554 661.675)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -151.104 641.935)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 1,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -153.899 644.73)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -156.699 647.53)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -165.195 627.845)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -167.99 630.64)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -170.79 633.44)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -179.425 613.615)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 3,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -182.22 616.41)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "3")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -185.02 619.21)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 2,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -193.624 599.415)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 4,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -196.419 602.21)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "4")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 0,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -199.219 605.01)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "0")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -201.197 579.061)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0,
  letterSpacing: ".1em"
}, "m"), /*#__PURE__*/React.createElement("tspan", {
  y: 0
}, "m")), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#1a1311",
  strokeMiterlimit: 10,
  "data-name": "Group 9821"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M408.927 789.174v-13.815m28.351 13.815v-13.815m28.346 13.815v-13.815m28.345 13.815v-13.815m28.348 13.815v-13.815m28.346 13.815v-13.815m28.346 13.815v-13.815m28.347 13.815v-13.815m28.346 13.815v-13.815m28.348 13.815v-13.815m28.344 13.815v-13.815m28.348 13.815v-13.815m28.346 13.815v-13.815m28.347 13.815v-13.815m28.343 13.815v-13.815",
  "data-name": "Path 6055"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M414.595 785.503v-10.144m28.347 10.144v-10.144m28.346 10.144v-10.144m28.348 10.144v-10.144m28.342 10.146v-10.146m28.345 10.146v-10.146m28.355 10.146v-10.146m28.346 10.146v-10.146m28.345 10.146v-10.146m28.347 10.146v-10.146m28.348 10.146v-10.146m28.345 10.146v-10.146m28.347 10.146v-10.146m28.346 10.146v-10.146m-362.837 10.144v-10.144m28.347 10.144v-10.144m28.348 10.144v-10.144m28.346 10.144v-10.144m28.345 10.146v-10.146m28.346 10.146v-10.146m28.348 10.146v-10.146m28.346 10.146v-10.146m28.345 10.146v-10.146m28.342 10.146v-10.146m28.348 10.146v-10.146m28.352 10.146v-10.146m28.346 10.146v-10.146m28.347 10.146v-10.146m-362.836 10.144v-10.144m28.343 10.144v-10.144m28.35 10.144v-10.144m28.35 10.144v-10.144m28.347 10.146v-10.146m28.346 10.146v-10.146m28.348 10.146v-10.146m28.345 10.146v-10.146m28.346 10.146v-10.146m28.347 10.146v-10.146m28.346 10.146v-10.146m28.347 10.146v-10.146m28.346 10.146v-10.146m28.347 10.146v-10.146m-362.838 10.144v-10.144m28.345 10.144v-10.144m28.348 10.144v-10.144m28.346 10.144v-10.144m28.345 10.146v-10.146m28.348 10.146v-10.146m28.341 10.146v-10.146m28.347 10.146v-10.146m28.353 10.146v-10.146m28.347 10.146v-10.146m28.346 10.146v-10.146m28.346 10.146v-10.146m28.347 10.146v-10.146m28.346 10.146v-10.146",
  "data-name": "Path 6056"
})), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 4,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -11.668 808.908)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "4")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 5,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -47.668 772.908)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "5")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 6,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -83.668 736.908)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "6")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 7,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -119.668 700.908)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "7")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 8,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -155.668 664.908)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "8")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  "data-name": 9,
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 10,
  fontWeight: 500,
  transform: "rotate(90 -191.668 628.908)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "9")), /*#__PURE__*/React.createElement("text", {
  fill: "#1a1311",
  fontFamily: "ItalianPlateNo2-Medium, Italian Plate No2",
  fontSize: 12,
  fontWeight: 500,
  transform: "rotate(90 -224.693 602.941)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0,
  letterSpacing: ".1em"
}, "i"), /*#__PURE__*/React.createElement("tspan", {
  y: 0
}, "n")), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#1a1311",
  strokeMiterlimit: 10,
  "data-name": "Group 9822"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M736.442 834.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6057"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M664.445 834.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6058"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M592.444 834.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6059"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M520.444 834.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6060"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M448.443 834.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6061"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M405.244 834.737v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979m7.2-9.979v9.979",
  "data-name": "Path 6062"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M801.243 830.067v14.649",
  "data-name": "Line 3277"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M729.243 830.067v14.649",
  "data-name": "Line 3278"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M729.243 830.067v14.649",
  "data-name": "Line 3279"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M657.244 830.067v14.649",
  "data-name": "Line 3280"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M585.244 830.067v14.649",
  "data-name": "Line 3281"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M513.245 830.067v14.649",
  "data-name": "Line 3282"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M441.245 830.067v14.649",
  "data-name": "Line 3283"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M729.243 830.067v14.649",
  "data-name": "Line 3284"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9824"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#07213f",
  d: "M947.682 825.932c-3.326 0-5.454 1.931-5.454 5.228 0 3.2 2.326 4.96 5.454 4.96 3.379 0 4.8-1.3 4.8-1.4v-4.378h-4.649v1.593h2.9v1.94a6.1 6.1 0 0 1-3.056.577c-1.929 0-3.708-.825-3.708-3.292a3.47 3.47 0 0 1 3.708-3.559 6.3 6.3 0 0 1 3.225.775l.717-1.541a8.1 8.1 0 0 0-3.943-.9Zm-88.386.17v9.891h6.243c2.686 0 3.291-1.473 3.291-3.03a2.36 2.36 0 0 0-1.421-2.183 2.15 2.15 0 0 0 .871-1.916c0-1.993-1.076-2.763-3.385-2.763Zm78.16 0v6.741l-5.877-6.555-.159-.175h-1.368V836h1.744v-6.847l6.15 6.843h1.257v-9.891Zm-53.053.009v9.877h8.342v-1.666h-6.6v-2.462h4.779v-1.594h-4.773v-2.487h6.587v-1.668Zm16.519 0v1.668h3.685v8.22h1.746v-8.22h3.685v-1.668Zm-4.971 0v9.877h1.744v-9.875Zm-23.91 0v9.887h1.745v-4.071h2.587l2.551 4.066h2.058l-2.647-4.066a2.74 2.74 0 0 0 2.733-2.928c0-2.371-1.844-2.885-3.559-2.885h-5.466Zm41.345 0V836h7.7v-1.665h-5.953v-8.22Zm10.528 0v9.887h1.745v-9.883Zm-62.911 1.554h3.825c1.054 0 1.729.422 1.729 1.239a1.2 1.2 0 0 1-1.338 1.333h-4.216zm12.785.044h3.746c.661 0 1.8.175 1.8 1.428 0 1.054-1.031 1.2-1.807 1.2h-3.739zm-12.785 4.09h4.3c.938 0 1.744.207 1.744 1.326s-.95 1.307-1.508 1.307h-4.536z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffc72c",
  d: "M842.748 829.468c-.516-.325-.009-.812.471-.812a2.48 2.48 0 0 1 1.468.687s-1.331.509-1.938.125m-7.156 6.862c-1.78.488-1.308-3.516.952-6.716a14.3 14.3 0 0 1 4.109-4.238c-.39 4.761-3.164 10.433-5.06 10.954m11.092-12.935a5.67 5.67 0 0 0-4.2.273v-.005a6.1 6.1 0 0 0-.2-2.663l-1.667.478a14 14 0 0 1 .111 3.045c-4.334 2.57-7.255 6.869-8.059 9.76-.878 3.148 1.57 4.218 3.63 2.669 5.086-3.827 6.119-12.534 6.119-12.534a3.55 3.55 0 0 1 3.47.411c1.8 1.591-.537 4.036-.537 4.036a2.7 2.7 0 0 0-1.742-.829c-1.821-.168-2.746 2.075-.33 2.315a5.1 5.1 0 0 0 1.876-.321c.4.767.282 4.322-2.058 5.373-2.1.944-2.882-.381-2.882-.381a6.6 6.6 0 0 0-1.074 1.574 3.07 3.07 0 0 0 3.555.973 5.53 5.53 0 0 0 3.345-3.533 5.24 5.24 0 0 0-.089-4.348c3.2-2.291 2.732-5.407.728-6.292"
})))));
export { SvgSizingRulerLarge as ReactComponent };
export default "/_next/static/images/sizing-ruler-large.svg";